"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dynamic_translations_html_1 = __importDefault(require("./dynamic-translations.html"));
require("./dynamic-translations.less");
(function (module) {
    function DynamicTranslationsController($scope, $filter, $timeout, widgetManager, dynamicTranslationsUtil, rsState, eventService) {
        var translate = $filter('translate');
        var $ctrl = this;
        $ctrl.fileToUpload = null;
        $ctrl.uploadFileButtonText = translate('CHOOSE_FILE');
        var changeFileString = translate('CHANGE_FILE');
        var IMPORT_STATUS_CODES = {
            PENDING: 'pending',
            SUCCEEDED: 'succeeded'
        };
        function setStatus(statusCode) {
            $ctrl.statusCode = statusCode;
            if (statusCode === IMPORT_STATUS_CODES.PENDING) {
                $ctrl.statusMessage = translate('PR.IMPORT_PENDING');
            }
            else if (statusCode === IMPORT_STATUS_CODES.SUCCEEDED) {
                $ctrl.statusMessage = translate('PR.IMPORT_SUCCESSFUL');
            }
        }
        function handleImportErrorMessage(error) {
            switch (error.status) {
                case 413:
                    $ctrl.errorMessage = translate('PR.IMPORT_DYNAMIC_TRANSLATIONS_FILE_TOO_LARGE');
                    break;
                default:
                    $ctrl.errorMessage = translate('PR.IMPORT_DYNAMIC_TRANSLATIONS_FAILED');
                    break;
            }
        }
        $scope.$ctrl = $ctrl;
        // methods called from the view
        angular.extend($ctrl, {
            //Returns a list of supported file formats
            getFormats: function getFormats() {
                return dynamicTranslationsUtil.getFormats();
            },
            // Handles the selection logic for the qmenu dropdown
            selectFileFormat: function selectFileFormat(idx) {
                $ctrl.format = this.getFormats()[idx];
            },
            // Exports the translation file in the selected file format
            exportDynamicTranslations: function exportDynamicTranslations() {
                dynamicTranslationsUtil.export($ctrl.format);
            },
            // Updates the file to upload
            updateFile: function updateFile(event) {
                var inputFile = (event.target.files || [])[0];
                if (!inputFile) {
                    return;
                }
                $ctrl.errorMessage = null;
                $ctrl.statusMessage = null;
                $ctrl.uploadedFileName = inputFile.name;
                $ctrl.uploadFileButtonText = changeFileString;
                $timeout(function () {
                    $ctrl.fileToUpload = inputFile;
                });
            },
            /**
             * Uploads the translation file to the translation service,
             * refreshes the widgets to pickup the new translations,
             * and notifies the user the status of the upload.
             */
            importDynamicTranslations: function importDynamicTranslations() {
                $ctrl.errorMessage = '';
                setStatus(IMPORT_STATUS_CODES.PENDING);
                dynamicTranslationsUtil.import($ctrl.fileToUpload)
                    .then(function () {
                    setStatus(IMPORT_STATUS_CODES.SUCCEEDED);
                    rsState.clearCache();
                    dynamicTranslationsUtil.getAndUpdateContainerMeta().finally(function () {
                        widgetManager.notifyAllWidgets('widgetSectionUpdated');
                    });
                    eventService.trigger('dynamicTranslationsUpdated');
                }).catch(function (error) {
                    console.error(error);
                    handleImportErrorMessage(error);
                });
            }
        });
        this.format = dynamicTranslationsUtil.getFormats()[0]; // default to the csv
    }
    DynamicTranslationsController.$inject = [
        '$scope',
        '$filter',
        '$timeout',
        'pr.widgetManager',
        'prDynamicTranslationsUtil',
        'rsState',
        'prEventService',
    ];
    module.component('prDynamicTranslations', {
        controller: DynamicTranslationsController,
        controllerAs: '$ctrl',
        templateUrl: dynamic_translations_html_1.default
    });
    module.controller('prDynamicTranslations', DynamicTranslationsController);
})(angular.module('qualtrics.pr'));
